<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('detail')" :butShow="true"></pageTitle>
        <Row class="mg-bottom20" v-if="info.status == 0">
          <Poptip
            placement="bottom"
            confirm
            :title="$t('confirm_apply_agree')"
            @on-ok="handleApplyAgree()"
          >
            <Button class="btn" type="primary">{{$t("apply_agree")}}</Button>
          </Poptip>
          <Button class="btn" @click="affirmReject()">{{$t("apply_reject")}}</Button>
        </Row>

        <myDetailCell :info="labels" :title="$t('school.base_info')">
          <template v-slot:payment_plan="{ data }">
            <div>{{ data.value.type }}</div>
          </template>
          <template v-slot:payment_plan_amount="{ data }">
            <div>{{ data.value.amount }}</div>
          </template>
          <template v-slot:school_cdesc="{ data }">
            <div :v-html="data.value.school_cdesc"></div>
          </template>
          <template v-slot:image="{ data }">
            <a
              v-if="imgList.length > 0"
              class="check"
              @click="handleCheckImage(data)"
            >{{ $t("home.check") }}</a>
          </template>
          <template v-slot:news="{ data }">
            <a class="check" @click="handleCheckNews(data)">{{$t("home.check")}}</a>
          </template>
        </myDetailCell>

        <div v-if="accounts.length > 0" class="mg-bottom20 pd-bottom10"></div>

        <myDetailCell
          v-if="accounts.length > 0"
          :info="accounts"
          :title="$t('school.login_account')"
        >
          <template v-slot:payment_plan="{ data }">
            <div>{{ data.value[0] }}</div>
          </template>
          <template v-slot:school_phone="{ data }">
            <div>{{ data.value.phone }}</div>
          </template>
          <template v-slot:school_email="{ data }">
            <div>{{ data.value.email }}</div>
          </template>
        </myDetailCell>
      </div>
      <div class="mg-bottom20"></div>

      <div class="table-box pd-20">
        <div class="table_title">{{$t('school.published_work')}}</div>
        <myTable
          ref="tables"
          :columns="columns"
          requestUrl="job/list"
          :showPage="true"
          :params="{school_id: id}"
        >
          <template v-slot:status="{ data }">
            <div class="df_center">
              <div :class="data.row.status == 1 ? 'blue' : 'grey'">{{ data.row.status_cdesc }}</div>
            </div>
          </template>
          <template v-slot:off_shelf="{ data }">
            <Poptip
              v-if="data.row.status == 1"
              placement="left"
              confirm
              :title="$t('confirm_off_shelf')"
              @on-ok="handleOffShelf(data.row)"
            >
              <a>{{ $t("off_shelf") }}</a>
            </Poptip>
            <span class="no_revert cursor_p" v-else>{{$t("off_shelf")}}</span>
          </template>
          <template v-slot:detail="{ data }">
            <!-- <Icon
              class="cursor_p"
              @click="handleToDetail(data.row)"
              type="ios-eye"
              size="26"
              color="#7D7C7F"
            />-->
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="handleToDetail(data.row)"
            />

            <!-- <a @click="handleToDetail(data.row)">{{$t("info")}}</a> -->
          </template>
        </myTable>
      </div>
      <div class="mg-bottom20"></div>
      <div class="table-box pd-20">
        <div class="table_title">{{$t('page_title.cent_list')}}</div>
        <myTable
          ref="table2"
          :columns="columns2"
          requestUrl="cent/list"
          :showPage="true"
          :params="{member_id: member_id}"
        ></myTable>
      </div>
      <div style="margin-bottom: 100px"></div>
    </div>

    <myCarouselModal
      :visible="imageModalVisible"
      :list="imgList"
      @onClose="imageModalVisible = false"
    />
    <newsModal :visible="newsModalVisible" @onClose="newsModalVisible = false" />
    <Modal
      v-model="modal"
      :title="$t('confirm_apply_reject')"
      @on-ok="handleApplyReject()"
      @on-cancel="modal = false"
      :loading="modalLoading"
    >
      <div class="modal_con">
        <Input
          v-model="reject_content"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          :placeholder="$t('server_no_rw_remark')"
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import myDetailCell from "@/components/myDetailCell";
import myTable from "@/components/myTable";
import myCarouselModal from "@/components/myCarouselModal";
import newsModal from "./newsModal";
import pageTitle from "@/components/pageTitle";

export default {
  name: "record_detail",
  components: {
    myDetailCell,
    myTable,
    myCarouselModal,
    newsModal,
    pageTitle
  },
  data () {
    return {
      id: this.$base.getRequest().id,
      member_id: "",
      pen: require("../../../assets/img/pen.png"),
      imageModalVisible: false,
      newsModalVisible: false,
      imgList: [],
      columns: [
        {
          title: this.$t("school.recruit_title"),
          key: "job_cname",
          align: "center"
        },
        {
          title: this.$t("release_status"),
          key: "release_status",
          align: "center",
          slot: "status"
        },
        {
          title: this.$t("look_count"),
          key: "view_times",
          align: "center"
        },
        {
          title: this.$t("deliver_count"),
          key: "post_times",
          align: "center"
        },
        {
          title: this.$t("last_update_time"),
          key: "entry_date",
          align: "center"
        },
        {
          title: this.$t("force_off_shelf"),
          key: "force_off_shelf",
          align: "center",
          slot: "off_shelf"
        },
        {
          title: this.$t("op"),
          key: "detail",
          align: "center",
          slot: "detail"
        }
      ],
      columns2: [
        {
          title: this.$t("Info.code"),
          tooltip: true,
          key: "member_id",
          align: "center"
        },
        {
          title: this.$t("order_code"),
          tooltip: true,
          key: "order_no",
          align: "center"
        },
        {
          title: this.$t("cent.time"),
          tooltip: true,
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("cent.expire_time"),
          tooltip: true,
          key: "expire_time",
          align: "center"
        },
        {
          title: this.$t("user"),
          tooltip: true,
          key: "member_cname",
          align: "center"
        },
        {
          title: this.$t("role"),
          tooltip: true,
          key: "role_cdesc",
          align: "center"
        },
        {
          title: this.$t("cent.integral"),
          tooltip: true,
          key: "in_count",
          align: "center"
        },
        {
          title: this.$t("cent.employ"),
          tooltip: true,
          key: "type_cdesc",
          align: "center"
        },
        {
          title: this.$t("status"),
          tooltip: true,
          key: "status_cdesc",
          align: "center"
        }
      ],
      labels: [],
      accounts: [],
      modal: false,
      reject_content: "",
      modalLoading: true,
      info: {}
    };
  },
  created () { },
  mounted () {
    this.getSchoolDetail();
  },
  methods: {
    getSchoolDetail () {
      this.$base.showLoading();
      this.$request.sendPost(
        "school/before-upd",
        { school_id: this.id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          const { info } = data;
          this.info = info;
          this.labels = [
            {
              label: this.$t("school_record.id"),
              value: info.school_id
            },
            {
              label: this.$t("school_record.name"),
              value: info["school_cname"]
            },
            {
              label: this.$t("contact_name"),
              value: info.contact_name
            },
            {
              label: this.$t("contact_mobile"),
              value: info.contact_mobile
            },
            { label: this.$t("email"), value: info.school_email },
            {
              label: this.$t("school.desc"),
              value: info.school_cdesc
            },
            {
              label: this.$t("school.address"),
              value: info.school_addr
            },
            {
              label: this.$t("school.image"),
              value: info.image,
              slot: "image"
            },
            // {
            //     label: this.$t("school.news"),
            //     value: info.news,
            //     slot: "news"
            // },
            {
              label: this.$t("school.join_time"),
              value: info.add_time
            },
            // {
            //     label: this.$t("vip_payment_plan"),
            //     value: { type: "月缴", amount: "HKD 88" },
            //     slot: "payment_plan",
            //     slot_two: "payment_plan_amount"
            // },
            {
              label: this.$t("vip_due_time"),
              value: info.renewal_time
            },
            {
              label: this.$t("cent.integral"),
              value: info.cent_remain
            },
            {
              label: this.$t("cent.cent_expire_time"),
              value: info.last_expire
            }
          ];
          let arr = [];
          info.members.forEach(e => {
            let obj = {
              label: e.member_cname,
              value: {
                phone: e.member_mobile,
                email: e.member_email
              },
              slot: "school_phone",
              slot_two: "school_email"
            };
            arr.push(obj);
          });
          this.accounts = arr;
          this.imgList = info.files;
          this.$refs.table2.reSearch({ member_id: this.info.member_id });
        }
      );
    },
    handleCheckImage (item) {
      this.imageModalVisible = true;
    },
    handleCheckNews (item) {
      this.newsModalVisible = true;
    },
    handleOffShelf (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        "job/upd-status",
        { job_id: item.job_id, status: 0 },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          //添加ref 运行子组件方法
          this.$refs.tables.getLoad();
        }
      );

    },
    affirmReject () {
      this.reject_content = "";
      this.modal = true;
    },
    handleApplyAgree () {
      this.$base.showLoading();
      this.$request.sendPost(
        "school/com",
        { school_id: this.id, status: 1 },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$base.linkBack();
        }
      );
    },

    handleApplyReject () {
      if (this.reject_content == "") {
        setTimeout(() => {
          this.modalLoading = false;
          this.$nextTick(() => {
            this.modalLoading = true;
          });
        }, 1000);
        return this.$base.msgErr(this.$t("no_server_rw_remark"));
      }
      this.$base.showLoading();
      this.$request.sendPost(
        "school/reject",
        { school_id: this.id, reject_content: this.reject_content },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) {
            this.$base.msgErr(error.errmsg);
            return (this.modal = false);
          }
          this.$base.msgSuccess(this.$t("op_ok"));
          this.modal = false;
          this.$base.linkBack();
        }
      );
    },
    handleToDetail (item) {
      this.$base.linkTo("/school/recruit_detail", { id: item.job_id });
    }
  }
};
</script>

<style lang="less" scoped>
.modal_con {
  padding: 0 20px;
}
.item {
  padding: 10px 0;
  display: flex;
}
/deep/ .table-box {
  .table_title {
    font-size: 18px;
    padding: 0 20px 10px 20px;
    font-weight: bold;
  }
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
  .check {
    color: var(--green_one);
    font-size: 14px;
    padding-left: 7px;
  }
  .blue {
    background-color: var(--blue_one);
    color: #fff;
    border-radius: 20px;
    width: 100px;
    padding: 3px 0;
  }
  .grey {
    background-color: #ccc;
    color: #fff;
    border-radius: 20px;
    width: 100px;
    padding: 3px 0;
  }
  .btn {
    font-size: 14px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/school/record/detail.vue